// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"47b28232","455":"0e51a69b","977":"06bfe224"}[chunkId] + ".chunk.js";
};